import axios from 'axios';
import { baseURL } from './types';

export const CREATE_BUSINESS_ADDON_REQUEST = 'CREATE_BUSINESS_ADDON_REQUEST';
export const CREATE_BUSINESS_ADDON_SUCCESS = 'CREATE_BUSINESS_ADDON_SUCCESS';
export const CREATE_BUSINESS_ADDON_FAILURE = 'CREATE_BUSINESS_ADDON_FAILURE';

export const GET_BUSINESS_ADDONS_REQUEST = 'GET_BUSINESS_ADDONS_REQUEST';
export const GET_BUSINESS_ADDONS_SUCCESS = 'GET_BUSINESS_ADDONS_SUCCESS';
export const GET_BUSINESS_ADDONS_FAILURE = 'GET_BUSINESS_ADDONS_FAILURE';

export const UPDATE_BUSINESS_ADDON_REQUEST = 'UPDATE_BUSINESS_ADDON_REQUEST';
export const UPDATE_BUSINESS_ADDON_SUCCESS = 'UPDATE_BUSINESS_ADDON_SUCCESS';
export const UPDATE_BUSINESS_ADDON_FAILURE = 'UPDATE_BUSINESS_ADDON_FAILURE';

export const DELETE_BUSINESS_ADDON_REQUEST = 'DELETE_BUSINESS_ADDON_REQUEST';
export const DELETE_BUSINESS_ADDON_SUCCESS = 'DELETE_BUSINESS_ADDON_SUCCESS';
export const DELETE_BUSINESS_ADDON_FAILURE = 'DELETE_BUSINESS_ADDON_FAILURE';

export const CLEAR_BUSINESS_ADDON_ERROR = 'CLEAR_BUSINESS_ADDON_ERROR';
export const CLEAR_BUSINESS_ADDON_SUCCESS = 'CLEAR_BUSINESS_ADDON_SUCCESS';

const API_BASE_URL = `${baseURL}/api`;

// Helper function to get authorization headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Create Business Addon (POST)
export const createBusinessAddon = (addonData) => async (dispatch) => {
  dispatch({ type: CREATE_BUSINESS_ADDON_REQUEST });
  try {
    const response = await axios.post(
      `${API_BASE_URL}/appointementAddonPackages/create`,
      addonData,
      { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
    );
    dispatch({
      type: CREATE_BUSINESS_ADDON_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_BUSINESS_ADDON_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Get Business Addons for Hospital (POST)
// export const getBusinessAddons = (hospitalID) => async (dispatch) => {
//   dispatch({ type: GET_BUSINESS_ADDONS_REQUEST });
//   try {
//     const response = await axios.post(
//       `${API_BASE_URL}/appointementAddonPackages/getall`,
//       hospitalID,
//       { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
//     );
    
//     if (response.data.success === 1) {
//       dispatch({
//         type: GET_BUSINESS_ADDONS_SUCCESS,
//         payload: response.data.data,
//       });
//     } else if (response.data.success === 0 && response.data.message === "No Business Addons records found") {
//       dispatch({
//         type: GET_BUSINESS_ADDONS_SUCCESS,
//         payload: [],
//       });
//     } else {
//       dispatch({
//         type: GET_BUSINESS_ADDONS_FAILURE,
//         payload: response.data.message || 'Failed to fetch business addons',
//       });
//     }
//     return response.data;
//   } catch (error) {
//     dispatch({
//       type: GET_BUSINESS_ADDONS_FAILURE,
//       payload: error.response?.data?.message || error.message,
//     });
//     throw error;
//   }
// };
// Updated businessAddonActions.js - FIXED VERSION
export const getBusinessAddons = (params) => async (dispatch) => {
  dispatch({ type: GET_BUSINESS_ADDONS_REQUEST });
  try {
    // Ensure params is always an object
    const payload = typeof params === 'object' ? params : { hospitalID: parseInt(params) };
    
    const response = await axios.post(
      `${API_BASE_URL}/appointementAddonPackages/getall`,
      payload,  // ✅ Always send as object
      { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
    );
    
    if (response.data.success === 1) {
      dispatch({
        type: GET_BUSINESS_ADDONS_SUCCESS,
        payload: response.data.data,
      });
    } else if (response.data.success === 0 && response.data.message === "No Business Addons records found") {
      dispatch({
        type: GET_BUSINESS_ADDONS_SUCCESS,
        payload: [],
      });
    } else {
      dispatch({
        type: GET_BUSINESS_ADDONS_FAILURE,
        payload: response.data.message || 'Failed to fetch business addons',
      });
    }
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_BUSINESS_ADDONS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};
// Get All Business Addons (POST)
export const getAllBusinessAddons = (filters = {}) => async (dispatch) => {
  dispatch({ type: GET_BUSINESS_ADDONS_REQUEST });
  try {
    const response = await axios.post(
      `${API_BASE_URL}/appointementAddonPackages/getall`,
      filters,
      { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
    );
    
    if (response.data.success === 1) {
      dispatch({
        type: GET_BUSINESS_ADDONS_SUCCESS,
        payload: response.data.data,
      });
    } else if (response.data.success === 0 && response.data.message === "No Business Addons records found") {
      dispatch({
        type: GET_BUSINESS_ADDONS_SUCCESS,
        payload: [],
      });
    } else {
      dispatch({
        type: GET_BUSINESS_ADDONS_FAILURE,
        payload: response.data.message || 'Failed to fetch business addons',
      });
    }
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_BUSINESS_ADDONS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Update Business Addon (PATCH with data in body)
export const updateBusinessAddon = (updateData) => async (dispatch) => {
  dispatch({ type: UPDATE_BUSINESS_ADDON_REQUEST });
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/appointementAddonPackages/update`,
      updateData,
      { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
    );
    dispatch({
      type: UPDATE_BUSINESS_ADDON_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: UPDATE_BUSINESS_ADDON_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Delete Business Addon (DELETE with data in body)
export const deleteBusinessAddon = (deleteData) => async (dispatch) => {
  dispatch({ type: DELETE_BUSINESS_ADDON_REQUEST });
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/appointementAddonPackages/delete`,
      { 
        headers: getAuthHeaders(),
        data: deleteData
      }
    );
    dispatch({
      type: DELETE_BUSINESS_ADDON_SUCCESS,
      payload: deleteData.id,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: DELETE_BUSINESS_ADDON_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Get Business Addon by ID (POST)
export const getBusinessAddonById = (addonId) => async (dispatch) => {
  dispatch({ type: GET_BUSINESS_ADDONS_REQUEST });
  try {
    const response = await axios.post(
      `${API_BASE_URL}/appointementAddonPackages/getById`,
      { id: parseInt(addonId) },
      { headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } }
    );
    
    if (response.data.success === 1) {
      dispatch({
        type: GET_BUSINESS_ADDONS_SUCCESS,
        payload: [response.data.data],
      });
    } else {
      dispatch({
        type: GET_BUSINESS_ADDONS_FAILURE,
        payload: response.data.message || 'Failed to fetch business addon',
      });
    }
    return response.data;
  } catch (error) {
    dispatch({
      type: GET_BUSINESS_ADDONS_FAILURE,
      payload: error.response?.data?.message || error.message,
    });
    throw error;
  }
};

// Clear error and success messages
export const clearBusinessAddonError = () => ({ 
  type: CLEAR_BUSINESS_ADDON_ERROR 
});

export const clearBusinessAddonSuccess = () => ({ 
  type: CLEAR_BUSINESS_ADDON_SUCCESS 
});